// The admin console for a Guest, in both interfaces (ADR-20260930,
// agion/Agion#2543): a Guest is an external person who works in the chat app
// on missions they are invited to. The console has nothing for them, so it
// says so and points to the chat app. The services refuse a Guest on every
// console route independently.
import { useTranslation } from 'react-i18next'
import { MessageSquare } from 'lucide-react'

/** The chat app lives on the app. host beside admin. (agion.dev, agion.cloud). */
export function chatAppUrl(location: Pick<Location, 'protocol' | 'host'> = window.location): string {
  const host = location.host.replace(/^admin\./, 'app.')
  return `${location.protocol}//${host}/`
}

export function GuestNotice() {
  const { t } = useTranslation('admin')
  return (
    <main className="flex min-h-screen items-center justify-center bg-[var(--background)] px-6" data-testid="guest-notice">
      <div className="flex max-w-[52ch] flex-col items-start gap-3">
        <h1 className="m-0 text-xl font-semibold text-text-primary">{t('guestNotice.title')}</h1>
        <p className="m-0 text-sm leading-relaxed text-text-muted">{t('guestNotice.body')}</p>
        <a
          href={chatAppUrl()}
          className="inline-flex items-center gap-2 rounded-md bg-[var(--action-primary)] px-3 py-2 text-sm font-medium text-[var(--action-primary-fg,white)]"
        >
          <MessageSquare className="h-4 w-4" aria-hidden="true" />
          {t('guestNotice.openChat')}
        </a>
      </div>
    </main>
  )
}
